import { Box, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { GuardedLink } from "../GuardedLink";

export const BackButton = styled(GuardedLink)<
  BoxProps
  & {$isMobile?: boolean}
>(({ $isMobile }) => ({
  fontSize: ($isMobile ? "0.75rem" : "1.125rem"),
  fontWeight: 400,
  lineHeight: $isMobile ? (11 / 6) : (11 / 9),
  minWidth: $isMobile ? "auto" : "128px",
  padding: $isMobile ? "16px 0 0 0" : undefined
}));

export const AdminBoxContainer = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px"
}));

export const LearnerBoxesContainer = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "30px"
}));

export const LearnerBoxesList = styled(Box)<
  BoxProps
>(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px"
}));

export const DomainBox = styled(Box)<
  BoxProps
  & {$isActive?: boolean}
>(({
  theme,
  $isActive
}) => {
  const borderColor = $isActive ? theme.customColors.systemSecondary01 : theme.customColors.border;

  return {
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      outline: `2px solid ${borderColor}`,
      outlineOffset: "2px"
    },
    "&:hover": {
      borderColor: $isActive ? borderColor : theme.customColors.borderAccent
    },
    alignItems: "center",
    border: `1px solid ${borderColor}`,
    borderRadius: theme.spacing(1),
    cursor: "pointer",
    display: "flex",
    minHeight: "2.75rem",
    padding: "0.5rem",
    transition: "border-color 0.2s ease-in-out"
  };
});
